(function() {
	'use strict';

/* -- Function -- */

	function openClose(profile) {
		if (profile.classList.contains('profiles--active')) {
			profile.classList.remove('profiles--active');
		} else {
			profile.classList.add('profiles--active');
			window.dataLayer.push({
				'event': 'Interactive', 'category': 'Interactive',
				'action': 'China_Government',
				'label': 'Accordion opened '+profile.id
			});
		}
	}

/* -- Application -- */

	function app() {
		window.dataLayer = window.dataLayer || [];

		// Go trough all the profile to add interaction
		const profiles = [].slice.call(document.querySelectorAll('.profiles__person'));
		profiles.forEach(function (profile) {
			// Get the elements that can be interact with to see more information
			// the action button, the photo, and the name
			const elements = [].slice.call(profile.querySelectorAll('.profiles__action, .person__photo, h3'));
			elements.forEach(element => element.addEventListener('click', () =>	openClose(profile)));
		});
	}

	// Start the whole thing when the DOM is complete
	document.addEventListener('readystatechange', function() {
		document.readyState === 'interactive' && app();
	}, false);

// end of the interactive
})();
